<template>
  <div class="default-wrapper">
    <b-modal
      v-if='removeArtistsCategoryModal'
      v-model='removeArtistsCategoryModal'
      ok-title="Tak"
      cancel-title="Nie"
      @ok='() => actions.handleRemoveArtistsCategory(itemToRemove)'
      centered
    >
      Czy usunąć kategorię <i>{{ itemToRemove.name['pl'] }}</i> ?
    </b-modal>

    <b-modal
      v-if='addArtistsCategoryModal'
      v-model='addArtistsCategoryModal'
      ok-title="Tak"
      cancel-title="Nie"
      @ok='() => handleAddArtistsCategory()'
      centered
    >
      <b-row>
        <b-col cols="6" v-for='(locale, i) in locales' :key='i' class='mb-3'>
          <div>
            <label>Nazwa {{ locale }}</label>
            <b-form-input
              v-model="artistsCategoryName[locale]"
            />
          </div>
        </b-col>
      </b-row>
    </b-modal>

    <b-modal
      v-if='removeDatePromptModal'
      v-model='removeDatePromptModal'
      ok-title="Tak"
      cancel-title="Nie"
      @ok='() => actions.handleRemoveDate(dateIdToRemove)'
      centered
    >
      Czy usunąć datę {{dateToRemove}}  ?
    </b-modal>

    <b-breadcrumb class='bread-crumb'>
      <b-breadcrumb-item :href='redirectTo'>{{label}}</b-breadcrumb-item>
      <b-breadcrumb-item active>Fanzone - <i>{{form.doc.name}}</i></b-breadcrumb-item>
    </b-breadcrumb>
    <loader v-if="loading && !form.doc" />
    <div v-else>
      <d-container fluid>
        <b-modal
          v-if='dataSavedModal'
          v-model='dataSavedModal'
          title='Sukces'
          ok-only
          centered
        >
          <div class="d-block text-center">
            Dane fanzone'a <i>{{form.doc.name}}</i> zostały zapisane.
          </div>
        </b-modal>
        <b-modal
          v-if='dataNotSavedModal'
          v-model='dataNotSavedModal'
          title='Uwaga'
          ok-only
          centered
        >
          <div class="d-block text-center">
            Zapis fanzone'a <i>{{form.doc.name}}</i> nie powiódł się.
          </div>
        </b-modal>
        <d-row no-gutters>
          <d-col cols="12">
            <d-form @submit="handleOnSubmit">
              <b-tabs content-class="mt-3" pills v-model="tabIndex">
                <b-tab title="Dane podstawowe">
                  <main-data :idStepsEvent='idStepsEvent' :idsRelatedEvents='idsRelatedEvents' />
                </b-tab>
                <b-tab title="Artyści">
                  <Artists />
                </b-tab>
                <b-tab title="Obrazki">
                  <main-images />
                </b-tab>
                <b-tab title="Menu">
                  <app-menu />
                </b-tab>
                <b-tab title="Banery">
                  <div class="form-inline">
                    <label>Banner - zostań liderem kroków</label>
                    <d-checkbox
                      class="ml-2 mr-sm-2 mb-sm-0"
                      v-model="form.doc.banner.steps"
                      @change='(e) => actions.handleNestedPropChanged("banner.steps", e != false)'
                    />
                  </div>
                  
                  <hr />
                  
                  <div class="form-inline">
                    <label>Banner - webview</label>
                    <d-checkbox
                      class="ml-2 mr-sm-2 mb-sm-0"
                      v-model="form.doc.banner.wv.active"
                      @change='(e) => actions.handleNestedPropChanged("banner.wv.active", e != false)'
                    />
                  </div>
                  
                  <div class="form-group mt-2">
                    <label>Tytuł</label>
                    <d-input
                      class="mb-4 mr-sm-2 mb-sm-0"
                      :value="form.doc.banner.wv.header"
                      @input='(e) => actions.handleNestedPropChanged("banner.wv.header", e)'
                      placeholder="Tytuł banneru"
                    />
                  </div>
                  
                  <div class="form-group mt-2">
                    <label>Podtytuł</label>
                    <d-input
                      class="mb-2 mr-sm-2 mb-sm-0"
                      :value="form.doc.banner.wv.subheader"
                      @input='(e) => actions.handleNestedPropChanged("banner.wv.subheader", e)'
                      placeholder="Podtytuł banneru"
                    />
                  </div>
                  
                  <div class="form-group mt-2">
                    <label>Link</label>
                    <d-input
                      class="mb-2 mr-sm-2 mb-sm-0"
                      :value="form.doc.banner.wv.url"
                      @input='(e) => actions.handleNestedPropChanged("banner.wv.url", e)'
                      placeholder="Webview link"
                    />
                  </div>
                  <div class="form-inline">
                    <div class="mr-4 mb-4">
                      <label>Kolor tekstów</label>
                      <material
                        @input='(e) => actions.handleNestedPropChanged("banner.wv.style.color", e.hex)'
                        :value="form.doc.banner.wv.style.color"
                        style="height:auto;width: 150px;"
                      />
                    </div>
                    
                    <div class="mr-4 mb-4">
                      <label>Tło</label>
                      <material
                        @input='(e) => actions.handleNestedPropChanged("banner.wv.style.bgc", e.hex)'
                        :value="form.doc.banner.wv.style.bgc"
                        style="height:auto;width: 150px;"
                      />
                    </div>
                  </div>
                </b-tab>
                
                <b-tab title="Buttony">
                  
                  <div id='stepsButtonContainer'>

                    <div class="form-inline mb-4">
                      <label>Button kroki</label>
                      <d-checkbox
                        class="ml-2 mr-sm-2 mb-sm-0"
                        v-model="form.doc.button.steps.visible"
                        @change='(e) => actions.handleNestedPropChanged("button.steps.visible", e != false)'
                      />
                    </div>
                    <div v-if='form.doc.button.steps.visible'>
                      <div class="form-inline">
                        <div class="mr-4 mb-4">
                          <label>Kolor tekstów</label>
                          <material
                            @input='(e) => actions.handleNestedPropChanged("button.steps.style.color", e.hex)'
                            :value="form.doc.button.steps.style.color"
                            style="height:auto;width: 150px;"
                          />
                        </div>
                        <div class="mr-4 mb-4">
                          <label>Tło</label>
                          <material
                            @input='(e) => actions.handleNestedPropChanged("button.steps.style.bgc", e.hex)'
                            :value="form.doc.button.steps.style.bgc"
                            style="height:auto;width: 150px;"
                          />
                        </div>
                        <div class="mr-4 mb-4">
                          <label>Kolor tekstów aktywny</label>
                          <material
                            @input='(e) => actions.handleNestedPropChanged("button.steps.style.colorActive", e.hex)'
                            :value="form.doc.button.steps.style.colorActive"
                            style="height:auto;width: 150px;"
                          />
                        </div>
                        <div class="mr-4 mb-4">
                          <label>Tło aktywne</label>
                          <material
                            @input='(e) => actions.handleNestedPropChanged("button.steps.style.bgcActive", e.hex)'
                            :value="form.doc.button.steps.style.bgcActive"
                            style="height:auto;width: 150px;"
                          />
                        </div>
                      </div>
                    </div>
                    <hr />
                  </div>

                  <div id='buyTicketButtonContainer'>
                    <div class="form-inline mb-4">
                      <label>Button kup bilet</label>
                      <d-checkbox
                        class="ml-2 mr-sm-2 mb-sm-0"
                        v-model="form.doc.button.buy_ticket.visible"
                        @change='(e) => actions.handleNestedPropChanged("button.buy_ticket.visible", e != false)'
                      />
                    </div>
                    <div v-if='form.doc.button && form.doc.button.buy_ticket && form.doc.button.buy_ticket.visible'>
                      <div class="form-inline">
                        <div class="mr-4 mb-4">
                          <label>Kolor tekstów</label>
                          <material
                            @input='(e) => actions.handleNestedPropChanged("button.buy_ticket.style.color", e.hex)'
                            :value="form.doc.button.buy_ticket.style.color"
                            style="height:auto;width: 150px;"
                          />
                        </div>
                        <div class="mr-4 mb-4">
                          <label>Tło</label>
                          <material
                            @input='(e) => actions.handleNestedPropChanged("button.buy_ticket.style.bgc", e.hex)'
                            :value="form.doc.button.buy_ticket.style.bgc"
                            style="height:auto;width: 150px;"
                          />
                        </div>
                        <div class="mr-4 mb-4">
                          <label>Kolor tekstów aktywny</label>
                          <material
                            @input='(e) => actions.handleNestedPropChanged("button.buy_ticket.style.colorActive", e.hex)'
                            :value="form.doc.button.buy_ticket.style.colorActive"
                            style="height:auto;width: 150px;"
                          />
                        </div>
                        <div class="mr-4 mb-4">
                          <label>Tło aktywne</label>
                          <material
                            @input='(e) => actions.handleNestedPropChanged("button.buy_ticket.style.bgcActive", e.hex)'
                            :value="form.doc.button.buy_ticket.style.bgcActive"
                            style="height:auto;width: 150px;"
                          />
                        </div>
                      </div>
                    </div>
                    <hr />
                  </div>
                  
                </b-tab>

                <b-tab title="Wygląd">
                  <div class="form-inline">
                    <div class="mr-4 mb-4">
                      <label>Kolor tekstów</label>
                      <material
                        @input='(e) => actions.handleNestedPropChanged("style.color", e.hex)'
                        :value="form.doc.style.color"
                        style="height:auto;width: 150px;"
                      />
                    </div>
                    <div class="mr-4 mb-4">
                      <label>Tło aktywne</label>
                      <material
                        @input='(e) => actions.handleNestedPropChanged("style.colorActive", e.hex)'
                        :value="form.doc.style.colorActive"
                        style="height:auto;width: 150px;"
                      />
                    </div>
                    <div class="mr-4 mb-4">
                      <label>Tekst aktywny</label>
                      <material
                        @input='(e) => actions.handleNestedPropChanged("style.colorActiveText", e.hex)'
                        :value="form.doc.style.colorActiveText"
                        style="height:auto;width: 150px;"
                      />
                    </div>
                    <div class="mr-4 mb-4">
                      <label>Nawigacja</label>
                      <material
                        @input='(e) => actions.handleNestedPropChanged("style.navcolor", e.hex)'
                        :value="form.doc.style.navcolor"
                        style="height:auto;width: 150px;"
                      />
                    </div>
                    <div class="mr-4 mb-4">
                      <label>Tło</label>
                      <material
                        @input='(e) => actions.handleNestedPropChanged("style.background", e.hex)'
                        :value="form.doc.style.background"
                        style="height:auto;width: 150px;"
                      />
                    </div>
                    <div class="mr-4 mb-4">
                      <label>Tytuł</label>
                      <material
                        @input='(e) => actions.handleNestedPropChanged("style.titlecolor", e.hex)'
                        :value="form.doc.style.titlecolor"
                        style="height:auto;width: 150px;"
                      />
                    </div>                    
                    <div class="mr-4 mb-4">
                      <label>Nagłówki</label>
                      <material
                        @input='(e) => actions.handleNestedPropChanged("style.headercolor", e.hex)'
                        :value="form.doc.style.headercolor"
                        style="height:auto;width: 150px;"
                      />
                    </div>
                    <div class="mr-4 mb-4">
                      <label>Podkreślenie menu</label>
                      <material
                        style="height:auto;width: 150px;"
                        @input='(e) => actions.handleNestedPropChanged("style.navUnderlineColor", e.hex)'
                        :value="form.doc.style.navUnderlineColor ? form.doc.style.navUnderlineColor : '#000000'"
                      />
                    </div>
                    <div class="mr-4 mb-4">
                      <label>Tło bocznego menu</label>
                      <material
                        style="height:auto;width: 150px;"
                        @input='(e) => actions.handleNestedPropChanged("style.sideMenuBackground", e.hex)'
                        :value="form.doc.style.sideMenuBackground ? form.doc.style.sideMenuBackground : ''"
                      />
                    </div>
                  </div>
                  <appearance />
                </b-tab>

                <b-tab title="Sceny">
                  <b-row>
                    <b-col>
                      <scenes />
                    </b-col>  
                  </b-row>        
                </b-tab>

                <b-tab title="Podstrony" class='mb-3'>
                  <b-row>
                    <b-col>
                      <flat-pages />
                    </b-col>  
                  </b-row>
                </b-tab>
                <b-tab title="Powiadomienia" class='mb-3'>
                  <b-row>
                    <b-col>
                      <notifications />
                    </b-col>  
                  </b-row>
                </b-tab>
                <b-tab title="Mapa" class='mb-3'>
                  <b-row>
                    <b-col>
                      <map-markers />
                    </b-col>  
                  </b-row>
                </b-tab>
                <b-tab title="Głosowanie" class='mb-3'>
                  <b-row>
                    <b-col>
                      <voting :id="id" />
                    </b-col>  
                  </b-row>
                </b-tab>
              </b-tabs>
              <b-row>
                <b-col>
                  <d-button type="submit">Zapisz fanzone</d-button>
                </b-col>
              </b-row>
            </d-form>
          </d-col>
          <!--
          <d-col class="ml-5">
            
            <div class="iphone-x">
              <div class="divider"></div>
              <div class="bezel"></div>
              <div
                class="screen"
                :style="{backgroundImage: `url(${form.doc.image_background_url})`}"
              >
                <div>
                  <div>
                    <span style="font-size:26px;" :style="{color: form.doc.style.navcolor}"></span>
                  </div>
                </div>
                <div
                  :style="{color: form.doc.style.navcolor}"
                  style="white-space:nowrap; margin-top:10px;"
                >
                  <span style="display:inline-block;margin-right:10px;">NEWSY</span>
                  <span style="display:inline-block;margin-right:10px;">ARTYŚCI</span>
                  <span style="display:inline-block;margin-right:10px;">WYDARZENIA</span>
                  <span style="display:inline-block;margin-right:10px;">MAPA</span>
                </div>
                <div style="text-align:center;padding:80px 20px;">
                  <h6 :style="{color: form.doc.style.titlecolor}">{{form.doc.openDates['pl']}}</h6>
                  <h5 :style="{color: form.doc.style.titlecolor}">{{form.doc.openTitle['pl']}}</h5>
                </div>
                <div
                  :style="{backgroundColor: form.doc.style.background}"
                  style="min-height:400px;margin:0 -20px;padding:20px;"
                >
                  <img
                    :src="steps"
                    alt
                    style="width:100%;height:auto;display:block;"
                    v-if="form.doc.banner.steps"
                  />
                  <d-card
                    v-if="form.doc.banner.wv.active"
                    style="border-radius: 4px"
                    class="mt-4 p-2"
                    :style="{backgroundColor: form.doc.banner.wv.style.bgc, color: form.doc.banner.wv.style.color}"
                  >
                    <span style="font-size: .9rem; font-weight: 500;">{{form.doc.banner.wv.header}}</span>
                    <span style="font-size: .8rem">{{form.doc.banner.wv.subheader}}</span>
                  </d-card>
                  <d-card style="margin-top:20px;">
                    <d-card-img
                      src="https://dummyimage.com/600x400/403e40/fff.png&text=News+placeholder"
                      style="height:180px;border-radius:8px 8px 0 0;"
                    />
                    <d-card-body>
                      <p>Nazwa newsa</p>
                    </d-card-body>
                  </d-card>
                </div>
              </div>
              <div class="speaker"></div>
              <div class="camera"></div>
              <div class="button mute"></div>
              <div class="button vol-up"></div>
              <div class="button vol-down"></div>
              <div class="button right"></div>
              <div class="divider"></div>
            </div>
            
          </d-col>
          -->
        </d-row>
      </d-container>
    </div>

    <d-modal v-if="artistModalVisible" @close="artistModalVisible = false">
      <d-modal-header>
        <d-input v-model="searchArtist" />
      </d-modal-header>
      <d-modal-body>
        <div
          v-for="(a, i) in filteredArtists"
          :key="i"
          @click="addArtistToEvent(a)"
          class="artist"
        >{{a.name}}</div>
      </d-modal-body>
    </d-modal>
  </div>
</template>

<script>
import { sendRequest, tokenRefresh } from "@/api";
import selectEventsList from '../SelectEventsList'
import { BModal } from 'bootstrap-vue'
import "tui-editor/dist/tui-editor.css";
import "tui-editor/dist/tui-editor-contents.css";
import "codemirror/lib/codemirror.css";
import Editor from "@toast-ui/vue-editor/src/Editor.vue";
import { Material } from "vue-color";
import steps from "@/assets/steps.png";
import { Settings } from "luxon";
import VueSimplemde from "vue-simplemde";
import { LOCALES } from '@/utils';
import FlatPages from '../FlatPages';
import MainData from './MainData'
import Artists from './Artists'
import MainImages from './MainImages'
import AppMenu from './AppMenu'
import Notifications from './Notifications'
import Scenes from './Scenes'
import MapMarkers from './MapMarkers'
import { BIconTrash } from 'bootstrap-vue'
import { Fragment } from 'vue-fragment'
import Voting from './Voting'
import Appearance from './Appearance'

import {
  handleUpdateFanzone,
  handleSimplePropChanged,
  handleSimplePropWithLocaleChanged,
  handleNestedPropChanged,
  handleSimpleArrayItemChanged,
  handleSimpleArrayOfObjectItemChanged,
  handleAddEvent,
  handleFillForm,
  handleRemoveArrayItem,
  getFormData,
  removeUnusedEvents,
  handleAddDate,
  handleRemoveDate,
  handleAddArtistsCategory,
  handleRemoveArtistsCategory,
} from '../../store/utils.js'

Settings.defaultLocale = "pl";

export default {
  props: ['id', 'redirectTo', 'label', 'idStepsEvent', 'idsRelatedEvents', 'scenesEditor'],
  components: {
    Editor,
    Material,
    VueSimplemde,
    selectEventsList,
    'b-modal': BModal,
    FlatPages,
    MainData,
    Artists,
    MainImages,
    AppMenu,
    Notifications,
    Scenes,
    MapMarkers,
    Voting,
    Appearance,
    BIconTrash,
    Fragment,
  },
  data() {
    return {
      removeDatePromptModal: false,
      artistsCategoryName: { pl: '', en: '' },
      addArtistsCategoryModal: false,
      removeArtistsCategoryModal: false,
      itemToRemove: null,
      dateToRemove: null,
      dateIdToRemove: null,
      dataSavedModal: false,
      dataNotSavedModal: false,
      actions: {
        handleUpdateFanzone,
        handleSimplePropChanged,
        handleSimplePropWithLocaleChanged,
        handleNestedPropChanged,
        handleSimpleArrayItemChanged,
        handleSimpleArrayOfObjectItemChanged,
        handleAddEvent,
        handleFillForm,
        handleRemoveArrayItem,
        handleAddDate,
        handleRemoveDate,
        handleAddArtistsCategory,
        handleRemoveArtistsCategory,
      },
      locales: LOCALES,
      loading: true,
      eventsModalVisible: false,
      steps: steps,
      activeDate: "",
      incrementor: 1,
      activeEvent: null,
      artistModalVisible: false,
      searchArtist: "",
      setupComplete: false,
      tabIndex: this.$route.query.callFrom === 'artist' ? 1 : 0
    };
  },
  computed: {
    artistsCategories() {
      try {
        return this.$store.state.fanzones.form.doc.scenesData.artistsCategories || [];
      } catch {
        return [];
      }
    },    
    isNew() {
      return typeof this.id === "undefined";
    },
    form() {
      return this.$store.state.fanzones.form
    },
    fanzone() {
      return this.$store.state.fanzones.fanzones.find(e => e.id == this.id);
    },
    scenes() {
      try {
        return this.$store.state.fanzones.form.doc.scenes.split(/\r?\n/).filter(e => e)
      } catch {
        return []
      }
    },
    filteredArtists() {
      return this.searchArtist == ""
        ? []
        : this.$store.state.artists.all.filter(
            a =>
              a.name.toLowerCase().indexOf(this.searchArtist.toLowerCase()) > -1 &&
              a.fanzine_id === this.$store.state.fanzones.form.id
          );
    }
  },
  mounted() {
    this.actions.handleFillForm(this.fanzone)
    this.setupComplete = true;
    this.loading = false;
  },
  watch: {
    'tabIndex': function() {
      const query = Object.assign({}, this.$route.query);
      delete query.callFrom;
      this.$router.replace({ query });
    },
    'form.doc.start': function() {
        this.computeDates()
    },
    'form.doc.end': function() {
        this.computeDates()
    }
  },
  methods: {
    handleAddArtistsCategory() {
      this.actions.handleAddArtistsCategory({ ...this.artistsCategoryName });
    },
    handleClickRemoveDate(id) {
      this.removeDatePromptModal = true
      this.dateIdToRemove = id
      this.dateToRemove = this.form.doc.dates[id].substr(0, 10)
    },
    handleAddDayScene() {
      this.actions.handleAddDate()
      //this.actions.handleSimplePropChanged("dates", daylist.map(v => v.toISOString().slice(0, 10)))
      //this.actions.handleSimplePropChanged("dateNames", daylist.map(v => v.toISOString().slice(0, 10)))
    },
    eventIdx(event) {
      let idx = 0;
      this.form.doc.events.map(
        (e, index) => {
          if (
            e.id === event.id &&
            e.date === event.date &&
            e.sceneName === event.sceneName &&
            e.eventName === event.eventName
          ) {
            idx = index
          }
        }
      )
      return idx
    },
    addArtistToEvent(a) {
      this.activeEvent.artistId = a.id;
      this.activeEvent.artistName = a.name;
      this.activeEvent.artistImage = a.image_url;
      this.activeEvent.eventName =
      this.activeEvent.eventName == "" ? a.name : this.activeEvent.eventName;
      this.artistModalVisible = false;
    },
    openArtistModal(e) {
      this.activeEvent = e;
      this.artistModalVisible = true;
    },
    getEventsFor(d, s) {
      try {
        return this.form.doc.events.filter(e => e.date == d && e.sceneName == s);
      } catch {
        return []
      }
    },
    async handleOnSubmit(e) {
      e.preventDefault()
      this.loading = true
      
      const form = removeUnusedEvents(this.form, this.scenes)
      const formData = getFormData(form)

      await tokenRefresh()
      const { ok, data } = await sendRequest(
        "post",
        `api/fanzine/${this.fanzone.idx}/update/`,
        formData,
        'text'
      );
      
      if (ok) {
        const { data: { fanzone } } = data
        this.actions.handleUpdateFanzone(fanzone)
        //this.$router.push(this.redirectTo)
        this.dataSavedModal = true
      } else {
        this.dataNotSavedModal = true
      }
      this.loading = false;
    },
    
    getDaysArray(start, end) {
      let arr = [];
      for (let dt = start; dt <= end; dt.setDate(dt.getDate() + 1)) {
        arr.push(new Date(dt));
      }
      return arr;
    },
    computeDates() {
      /*
      const { start, end } = this.form.doc
      if (start != "" && end != "") {
        let daylist = this.getDaysArray(
          new Date(start),
          new Date(end)
        );

        this.actions.handleSimplePropChanged("dates", daylist.map(v => v.toISOString().slice(0, 10)))
        this.actions.handleSimplePropChanged("dateNames", daylist.map(v => v.toISOString().slice(0, 10)))

        if (this.form.doc.dates.length > 0) {
          this.activeDate = this.form.doc.dates[0];
        }
      }
      */
    }
  },
};
</script>

<style lang="scss" scoped>
@import "~simplemde/dist/simplemde.min.css";
.iphone-x {
  height: 724px;
  width: 357px;
  background-image: linear-gradient(
    top,
    rgba(255, 255, 255, 1) 0%,
    rgba(255, 255, 255, 1) 1%,
    rgba(0, 0, 0, 1) 2%,
    rgba(255, 255, 255, 1) 5%,
    rgba(255, 255, 255, 1) 95%,
    rgba(0, 0, 0, 1) 98%,
    rgba(255, 255, 255, 1) 99%,
    rgba(255, 255, 255, 1) 100%
  );
  margin: 30px auto;
  border-radius: 55px;
  box-sizing: border-box;
  border: 2px solid black;
  box-shadow: inset 0px 0px 7px 0px rgba(0, 0, 0, 0.75);
  position: sticky;
  top: 50px;
}

.divider {
  background: #aaaaaa;
  height: 5px;
  width: 100%;
  position: absolute;
  &:first-of-type {
    top: 9%;
  }
  &:last-of-type {
    bottom: 9%;
  }
}

.bezel {
  width: calc(100% - 10px);
  height: calc(100% - 10px);
  background: #565656;
  background-image: linear-gradient(
    top,
    rgba(106, 106, 106, 1) 0%,
    rgba(0, 0, 0, 1) 1%,
    rgba(86, 86, 86, 1) 4%,
    rgba(86, 86, 86, 1) 96%,
    rgba(0, 0, 0, 1) 99%,
    rgba(106, 106, 106, 1) 100%
  );
  position: relative;
  left: 5px;
  top: 5px;
  border-radius: 48px;
  border-left: 3px solid black;
  border-right: 3px solid black;
  border-top: 3px solid #484848;
  border-bottom: 3px solid #0d0d0d;
  box-sizing: border-box;
  box-shadow: inset 0px 0px 7px 0px rgba(190, 190, 190, 0.8);
  z-index: 2;

  &::after {
    content: "";
    width: calc(100% - 14px);
    height: calc(100% - 14px);
    background: #000;
    position: absolute;
    top: 7px;
    left: 7px;
    border-radius: 40px;
  }
}

.screen {
  z-index: 3;
  width: calc(100% - 40px);
  height: calc(100% - 40px);
  position: absolute;
  top: 20px;
  left: 20px;
  border-radius: 35px;
  overflow: hidden;
  background-size: cover;
  padding: 30px 20px 0;

  &::after {
    content: "";
    width: 56%;
    height: 4%;
    background: #000;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
                // ...

    margin: 0 auto;
    border-radius: 0 0 20px 20px;
  }
}

.speaker {
  width: 48px;
  height: 5px;
  position: absolute;
  background: #1c1c1c;
  top: 3.75%;
  z-index: 4;
  left: 0;
  right: 0;
  margin: 0 auto;
  border-radius: 3px;
}

.camera {
  height: 10px;
  width: 10px;
  border-radius: 50%;
  // background: #1b1c20;
  position: absolute;
  z-index: 4;
  top: 3.5%;
  right: 38%;
  background-image: radial-gradient(
    center,
    rgba(2, 26, 60, 1) 0%,
    rgba(49, 62, 79, 1) 8%,
    rgba(31, 62, 108, 1) 21%,
    rgba(2, 26, 60, 1) 56%,
    rgba(2, 26, 60, 1) 100%
  );
}

.button {
  width: 4px;
  position: absolute;
  z-index: 5;
  background-image: linear-gradient(
    top,
    rgba(0, 0, 0, 1) 0%,
    rgba(244, 244, 244, 1) 15%,
    rgba(244, 244, 244, 1) 85%,
    rgba(0, 0, 0, 1) 100%
  );
  box-sizing: border-box;
  border-left: 1px solid #cdcdcd;
  border-right: 1px solid #303030;
}

.button.mute {
  height: 28px;
  top: 13%;
  left: -4px;
}

.button.vol-up,
.button.vol-down {
  height: 53px;
  left: -4px;
}

.button.vol-up {
  top: 21%;
}

.button.vol-down {
  top: 30%;
}

.button.right {
  right: -4px;
  height: 84px;
  top: 23.5%;
  border-right: 1px solid #cdcdcd;
  border-left: 1px solid #303030;
}
.bread-crumb {
  margin-left: -25px;
  margin-right: -24px;
  margin-top: -25px;
  padding-left: 26px;
  background: #d5e7f5;
}
</style>